export default "__VITE_ASSET__DWQEokh7__"